import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';
import TextField, { TextFieldProps } from '@mui/material/TextField';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  mask?: string;
};

export default function RHFTextField({ name, helperText, mask, type, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        if (mask) {
          return (
            <InputMask mask={mask} {...field} maskChar="">
              {() => (
                <TextField
                  fullWidth
                  error={!!error}
                  helperText={error ? error?.message : helperText}
                  {...other}
                />
              )}
            </InputMask>
          );
        }

        return (
          <TextField
            {...field}
            fullWidth
            type={type}
            value={type === 'number' && field.value === 0 ? '' : field.value}
            onChange={(event) => {
              const { value } = event.target;
              if (type === 'number') {
                if (/^\d*\.?\d*$/.test(value)) {
                  field.onChange(Number(value));
                }
              } else {
                field.onChange(value);
              }
            }}
            onKeyDown={(e) => {
              if (
                (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') &&
                type === 'number'
              ) {
                e.preventDefault();
              }
            }}
            error={!!error}
            helperText={error ? error?.message : helperText}
            {...other}
          />
        );
      }}
    />
  );
}
